import { G, Text, Path, Circle } from "@react-pdf/renderer";
import svgpath from "svgpath";
//var svgpath = require("svgpath");

const Handoff = (props) => {
  let { x, y, width, color } = props;
  return (
    <>
      <Path
        strokeWidth={width / (150 / 12)}
        stroke={color}
        fill="none"
        d={`M ${x - width / 2} ${y} ${x + width / 2} ${y}`}
      />
      <Path
        strokeWidth={width / (150 / 12)}
        stroke={props.color}
        fill="none"
        d={`M ${x - width / 6} ${y - width / 3} ${x - width / 6} ${
          y + width / 3
        }`}
      />
      <Path
        strokeWidth={width / (150 / 12)}
        stroke={props.color}
        fill="none"
        d={`M ${x + width / 6} ${y - width / 3} ${x + width / 6} ${
          y + width / 3
        }`}
      />
    </>
  );
};

const Cone = (props) => {
  let { x, y, width } = props;
  let rawPath =
    "M90.34,76.81a3.78,3.78,0,0,1-2.42,3.53L55.57,92.76a15.53,15.53,0,0,1-11.15,0L12.08,80.34a3.79,3.79,0,0,1-1.65-5.82,3.74,3.74,0,0,1,2-1.35l9.22-2.56a7.09,7.09,0,0,0,3.69,7A51.84,51.84,0,0,0,50,84.19,52,52,0,0,0,74.67,77.6a7.08,7.08,0,0,0,3.68-7l9.22,2.55A3.77,3.77,0,0,1,90.34,76.81ZM74.27,70.5,55.34,8c-.72-2.36-9.93-2.36-10.67,0L25.74,70.5a3.06,3.06,0,0,0,1.49,3.57q22.77,12.24,45.55,0A3.06,3.06,0,0,0,74.27,70.5Z";
  let convertedPath = svgpath(rawPath)
    .scale((1 / 100) * width)
    .translate(x - width / 2, y - width / 2)
    .toString();

  return <Path fill={props.color} d={convertedPath} />;
};

export default function PdfPlayer({ stance = "regular", ...props }) {
  let { coneWidth, playerCircleRadius, handOffWidth } = props.objectSizes;

  coneWidth *= props.objectSizeFactor;
  playerCircleRadius *= props.objectSizeFactor;
  handOffWidth *= props.objectSizeFactor;

  let angle = (props.angle ?? 0) + (props.court.full ? -90 : 0);

  return (
    <>
      {props.team === "ball" && (
        <Circle
          cx={props.pos[0]}
          cy={props.pos[1]}
          r={(playerCircleRadius * 47) / 50}
          fillOpacity={0}
          stroke={props.color}
          strokeWidth={playerCircleRadius * 2 * 0.07}
          shapeRendering="geometricPrecision"
        />
      )}

      {(props.team === "offense" || props.team === "ball") && props.number && (
        <Text
          style={{
            fontFamily: "Roboto",
            fontWeight: "bold",
            fontSize:
              props.number.toString().length === 1
                ? 0.7 * 2 * playerCircleRadius + "px"
                : 0.5 * 2 * playerCircleRadius + "px",
          }}
          textAnchor="middle"
          dominantBaseline="central"
          stroke={props.color}
          fill={props.color}
          color={props.color}
          x={props.pos[0]}
          y={props.pos[1]}
        >
          {props.number}
        </Text>
      )}

      {props.team === "defense" && (
        <>
          <Path
            stroke={props.color}
            strokeWidth={0.18 * playerCircleRadius}
            d={svgpath("M -30 -24 10 24")
              .scale(0.01 * playerCircleRadius * 2)
              .translate(props.pos[0], props.pos[1])
              .toString()}
          />

          <Path
            stroke={props.color}
            strokeWidth={0.18 * playerCircleRadius}
            d={svgpath("M 10 -24 -30 24")
              .scale(0.01 * playerCircleRadius * 2)
              .translate(props.pos[0], props.pos[1])
              .toString()}
          />
          {props.number && (
            <Text
              style={{
                fontWeight: "700",
                fontSize:
                  props.number.toString().length <= 1
                    ? 0.45 * 2 * playerCircleRadius
                    : 0.3 * 2,

                lineHeight:
                  props.number.toString().length <= 1
                    ? 0.45 * 2 * playerCircleRadius
                    : 0.3 * 2,
              }}
              textAnchor="middle"
              dominantBaseline="central"
              fill={props.color}
              x={props.pos[0] + 0.3 * 2 * playerCircleRadius}
              y={props.pos[1] + 0.2 * 2 * playerCircleRadius}
            >
              {props.number}
            </Text>
          )}
        </>
      )}

      {props.team === "defense_alt" && (
        <>
          {stance === "regular" && (
            <>
              <Path
                stroke={props.color}
                strokeWidth={0.18 * playerCircleRadius}
                d={svgpath("M -110 20 Q -80 -10 -40 0")
                  .scale(0.01 * playerCircleRadius * 2)
                  .translate(props.pos[0], props.pos[1])
                  .rotate(angle, props.pos[0], props.pos[1])
                  .toString()}
              />

              <Path
                stroke={props.color}
                strokeWidth={0.18 * playerCircleRadius}
                d={svgpath("M 110 20 Q 80 -10 40 0")
                  .scale(0.01 * playerCircleRadius * 2)
                  .translate(props.pos[0], props.pos[1])
                  .rotate(angle, props.pos[0], props.pos[1])
                  .toString()}
              />
            </>
          )}
          {stance === "box_out_right" && (
            <>
              <Path
                stroke={props.color}
                strokeWidth={0.18 * playerCircleRadius}
                d={svgpath("M -40 0 Q -60 0 -60 35 Q -60 70 -30 70 L 40 70")
                  .scale(0.01 * playerCircleRadius * 2)
                  .translate(props.pos[0], props.pos[1])
                  .rotate(angle, props.pos[0], props.pos[1])
                  .toString()}
              />
            </>
          )}
          {stance === "box_out_left" && (
            <>
              <Path
                stroke={props.color}
                strokeWidth={0.18 * playerCircleRadius}
                d={svgpath("M 40 0 Q 60 0 60 35 Q 60 70 30 70 L -50 70 ")
                  .scale(0.01 * playerCircleRadius * 2)
                  .translate(props.pos[0], props.pos[1])
                  .rotate(angle, props.pos[0], props.pos[1])
                  .toString()}
              />
            </>
          )}
          {stance === "off_ball" && (
            <>
              <Path
                stroke={props.color}
                strokeWidth={0.18 * playerCircleRadius}
                d={svgpath("M -70 15 Q -60 -10 -40 0")
                  .scale(0.01 * playerCircleRadius * 2)
                  .translate(props.pos[0], props.pos[1])
                  .rotate(angle, props.pos[0], props.pos[1])
                  .toString()}
              />

              <Path
                stroke={props.color}
                strokeWidth={0.18 * playerCircleRadius}
                d={svgpath("M 70 15 Q 60 -10 40 0")
                  .scale(0.01 * playerCircleRadius * 2)
                  .translate(props.pos[0], props.pos[1])
                  .rotate(angle, props.pos[0], props.pos[1])
                  .toString()}
              />
            </>
          )}
          {stance === "deny_right" && (
            <Path
              stroke={props.color}
              strokeWidth={0.18 * playerCircleRadius}
              d={svgpath("M -110 20 Q -80 -10 -40 0")
                .scale(0.01 * playerCircleRadius * 2)
                .translate(props.pos[0], props.pos[1])
                .rotate(angle, props.pos[0], props.pos[1])
                .toString()}
            />
          )}
          {stance === "deny_left" && (
            <Path
              stroke={props.color}
              strokeWidth={0.18 * playerCircleRadius}
              d={svgpath("M 110 10 Q 80 -20 40 0")
                .scale(0.01 * playerCircleRadius * 2)
                .translate(props.pos[0], props.pos[1])
                .rotate(angle, props.pos[0], props.pos[1])
                .toString()}
            />
          )}
          <Circle
            cx={props.pos[0]}
            cy={props.pos[1]}
            r={(playerCircleRadius * 35) / 50}
            fill={props.color}
            stroke={props.color}
            strokeWidth={0.18 * playerCircleRadius}
            shapeRendering="geometricPrecision"
          />
          {props.number && (
            <Text
              style={{
                fontFamily: "Roboto",
                fontWeight: "bold",
                fontSize:
                  props.number.toString().length === 1
                    ? 0.5 * 2 * playerCircleRadius + "px"
                    : 0.4 * 2 * playerCircleRadius + "px",
              }}
              textAnchor="middle"
              dominantBaseline="central"
              stroke={"#eee"}
              fill={"#eee"}
              //color={props.color}
              x={props.pos[0]}
              y={props.pos[1]}
            >
              {props.number}
            </Text>
          )}
        </>
      )}

      {props.subType === "handoff" && (
        <Handoff
          color={props.color}
          width={handOffWidth}
          x={props.pos[0]}
          y={props.pos[1]}
        />
      )}

      {props.subType === "cone" && (
        <Cone
          color={props.color}
          width={coneWidth}
          x={props.pos[0]}
          y={props.pos[1]}
        />
      )}
    </>
  );
}
